<template>
  <v-card flat>
    <v-card-text class="pt-6">
      <ValidationObserver ref="observer">
        <v-form ref="form" :readonly="loadingFormProfile">
          <ValidationProvider
            name="New Password"
            rules="required|min:6"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              outlined
              label="Password Baru"
              color="light-green"
              v-model="form.password"
              :error-messages="formErrors.password || errors"
              :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPass ? 'text' : 'password'"
              @click:append="showPass = !showPass"
            >
            </v-text-field>
          </ValidationProvider>
          <ValidationProvider
            name="Password Confirmation"
            rules="required|min:6"
            v-slot="{ errors }"
          >
            <v-text-field
              dense
              outlined
              label="Konfirmasi Password"
              color="light-green"
              v-model="form.password_confirmation"
              :error-messages="formErrors.password_confirmation || errors"
              :append-icon="showConPass ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showConPass ? 'text' : 'password'"
              @click:append="showConPass = !showConPass"
            >
            </v-text-field>
          </ValidationProvider>
        </v-form>
      </ValidationObserver>
      <v-alert v-if="error.message" text type="error" class="custom-alert my-4">
        <p class="body-2 mb-0">
          {{ error.message }}
        </p>
      </v-alert>
    </v-card-text>
    <v-card-actions class="pb-6 px-6">
      <v-spacer></v-spacer>
      <v-btn
        color="light-green"
        dark
        elevation="0"
        :disabled="loadingFormProfile"
        :loading="loadingFormProfile"
        @click="save"
        class="text-capitalize"
      >
        Simpan
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapState } from 'vuex';
import profile from '@/mixins/profile';
export default {
  mixins: [profile],
  data() {
    return {
      showPass: false,
      showConPass: false,
      form: {
        password: '',
        password_confirmation: ''
      }
    };
  },
  computed: mapState(['user']),
  methods: {
    async save() {
      this.clearError();
      const isValid = await this.$refs.observer.validate();
      if (isValid) {
        try {
          await this.updatePassword(this.form);
          this.$refs.form.reset();
          this.$refs.observer.reset();
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error(e);
        }
      }
    }
  }
};
</script>
